// src/components/Image/ImagePreview.tsx
import React, { CSSProperties } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useTranslation } from "react-i18next";
import { ImagePreviewProps } from "../../types/screensTypes";
import Button from "../ui/Button";
import styles from "./ImagePreview.module.css";

const ImagePreview: React.FC<ImagePreviewProps> = ({ id, photo, onDelete }) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const style: CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <div className={styles.container}>
            <div ref={setNodeRef} style={style} {...attributes} {...listeners} className={styles.imageBox}>
                <img src={photo} alt="Uploaded preview" className={styles.image} />
            </div>
            <div className={styles.deleteWrap}>
                <Button label={t("closeDelete")} onClick={() => onDelete()} variant="danger" isSmall preventDefault />
            </div>
        </div>
    );
};

export default ImagePreview;
